import type { CapiProductPage } from 'types/capi/pdp';

import usePageData from '~/hooks/usePageData';
import gtm from '~/services/gtm.client';

import ProductCardCarousel from './ProductCardCarousel';

const WhatsHot = () => {
  const product = usePageData<CapiProductPage>();

  const sendGtmEvent = () => {
    gtm.sendUserInteractionEvent("What's Hot View More Drops", 'Body');
  };

  return (
    <ProductCardCarousel
      title="What's Hot"
      viewMoreCopy="View more drops"
      onViewMoreProductsClick={sendGtmEvent}
      viewMoreUrl={product.view_more_products_path}
      id="featured-products"
      products={product.featured_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const RelatedProducts = () => {
  const product = usePageData<CapiProductPage>();

  return (
    <ProductCardCarousel
      title="Similar products"
      id="similar-products"
      products={product.related_products}
      padImages={product.pad_images}
      allowNotifications={product.allow_user_notifications}
    />
  );
};

const ProductCardCarousels = () => {
  const products = usePageData<CapiProductPage>();

  const showRelatedProductCarousel = products.related_products.length !== 0;

  return (
    <div className="flex flex-col gap-4 bg-concrete">
      {showRelatedProductCarousel && (
        <>
          <div className="mx-auto max-w-6xl p-3 md:px-8">
            <RelatedProducts />
          </div>
          <hr className="border-b-1 w-full border-grey-midnight-read" />
        </>
      )}

      <div className="mx-auto max-w-6xl p-3 md:px-8">
        <WhatsHot />
      </div>
    </div>
  );
};

export default ProductCardCarousels;
